import PropTypes from 'prop-types';
import { FormControlLabel } from '@mui/material';

import { componentsSize } from 'constants/components';

import Checkbox from '../Checkbox';

const styles = {
  label: (size) =>
    size === componentsSize.large ? { alignItems: 'flex-start', gap: 4 } : { alignItems: 'center', gap: 1 },
};

const CheckboxWithLabel = ({ checkboxProps, label, size = componentsSize.large }) => (
  <FormControlLabel sx={styles.label(size)} control={<Checkbox {...checkboxProps} />} label={label} />
);

CheckboxWithLabel.propTypes = {
  checkboxProps: PropTypes.shape({
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    inputProps: PropTypes.objectOf(PropTypes.string),
    onChange: PropTypes.func,
    isHeader: PropTypes.bool,
    innerRef: PropTypes.func,
    label: PropTypes.string,
  }).isRequired,
  label: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.values(componentsSize)),
};
export default CheckboxWithLabel;
